export class DocsAnalyticsTimeFrame {
    constructor(model) {
        this.start = new Date(model.start);
        this.end = model.end ? new Date(model.end) : null;
    }
}
